import React from 'react'

/** Skeleton loaders (Lee, 26 Oct 2026 — the "sleek & modern" pass): grey
 *  placeholder shapes with a shimmer (the `.skeleton` class in global.css)
 *  instead of bare "Loading…" text, so pages look structured the instant they
 *  open. Keep them roughly the shape of the real content. */

export const Skeleton: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`skeleton ${className}`} aria-hidden="true" />
)

/** A column of bars fading out downwards — stands in for any list or table. */
export const SkeletonRows: React.FC<{ rows?: number; rowClass?: string; className?: string }> = ({
  rows = 6,
  rowClass = 'h-9',
  className = '',
}) => (
  <div className={`space-y-2.5 ${className}`} aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className={`skeleton ${rowClass}`} style={{ opacity: Math.max(0.25, 1 - i * 0.13) }} />
    ))}
  </div>
)

/** A page-shaped placeholder: title bar + content rows. */
export const SkeletonPage: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`p-4 space-y-4 ${className}`} aria-hidden="true">
    <div className="skeleton h-7 w-56" />
    <div className="flex gap-2">
      <div className="skeleton h-8 w-24" />
      <div className="skeleton h-8 w-24" />
      <div className="skeleton h-8 w-24" />
    </div>
    <SkeletonRows rows={7} rowClass="h-11" />
  </div>
)
